import { Routes } from '@angular/router';
import { driverAdminGuard, guestGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'signup',
    title: 'Delivery Team Signup',
    loadComponent: () =>
      import('./features/delivery-signup/delivery-signup').then(
        (m) => m.DeliverySignupComponent,
      ),
  },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/login.component').then(
        (m) => m.DeliveryAdminLoginComponent,
      ),
  },
  {
    path: 'app',
    canActivate: [driverAdminGuard],
    loadComponent: () =>
      import('./layouts/dashboard/dashboard').then((x) => x.Dashboard),
    loadChildren: () => import('./shared/dashboard-routes'),
  },
  {
    path: 'forbidden',
    title: 'Access Forbidden',
    data: {
      code: '403',
      title: 'Access forbidden',
      message: 'Your account does not have the Driver Admin role.',
    },
    loadComponent: () =>
      import('./features/status/status-page.component').then(
        (m) => m.StatusPageComponent,
      ),
  },
  {
    path: 'not-found',
    title: 'Page Not Found',
    data: {
      code: '404',
      title: 'Page not found',
      message: 'The requested Driver Admin page does not exist.',
    },
    loadComponent: () =>
      import('./features/status/status-page.component').then(
        (m) => m.StatusPageComponent,
      ),
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'not-found' },
];
